import { useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useRestaurantContext } from "@/contexts/RestaurantContext";

interface StockSettings {
  stockBlockSales: boolean;
  lowMarginAlertPercentage: number;
}

export function useStockSettings() {
  const { activeRestaurant, refetch } = useRestaurantContext();
  const [isUpdating, setIsUpdating] = useState(false);

  const settings: StockSettings = {
    stockBlockSales: (activeRestaurant as any)?.stock_block_sales || false,
    lowMarginAlertPercentage: (activeRestaurant as any)?.low_margin_alert_percentage || 30,
  };

  const updateSettings = useCallback(async (newSettings: Partial<StockSettings>) => {
    if (!activeRestaurant) return false;

    setIsUpdating(true);
    try {
      const updateData: Record<string, any> = {};
      
      if (newSettings.stockBlockSales !== undefined) {
        updateData.stock_block_sales = newSettings.stockBlockSales;
      }
      if (newSettings.lowMarginAlertPercentage !== undefined) {
        updateData.low_margin_alert_percentage = newSettings.lowMarginAlertPercentage;
      }

      const { error } = await supabase
        .from("restaurants")
        .update(updateData)
        .eq("id", activeRestaurant.id);

      if (error) throw error;

      await refetch();
      return true;
    } catch (error) {
      console.error("Error updating stock settings:", error);
      return false;
    } finally {
      setIsUpdating(false);
    }
  }, [activeRestaurant, refetch]);

  return {
    ...settings,
    isUpdating,
    updateSettings,
  };
}
